import { gql } from '@/utilities/gql';
import { makeGqlQuery } from '@/utilities/gqlQuery';
import type { ResultOf } from '@/utilities/gql';

const QUERY = gql(`
  query userScreener(
    $id: Float!
  ) {
    userScreener( id: $id ) {
      id
      name
      slug
      filterJson
      description
      onlyMarketFiltered
      imageUrl
      modifyDate
      status
      type {
        slug
      }
    }
  }
`);

export type UserScreenerGqlResponse = ResultOf<typeof QUERY> | undefined;

export const useGqlUserScreener = makeGqlQuery(QUERY);
